<!-- RESULT COUNT -->
<div
   *ngIf="isLoaded || (total > 0 && !isLoaded)"
   class="result-count">
   {{ resultCount }}
   <button
      *ngIf="searchService.suggestedSearch.show"
      (click)="searchService.performSuggestedSearch()"
      class="suggested-search">
      Did you mean {{ searchService.suggestedSearch.keyword }}?
   </button>
</div>

<app-scroll-container>
   <ng-template bodyTemplate>
      <div
         [ngClass]="{
            'search-result-container': true,
            'no-results': !searchResults.length,
         }"
         data-scrollable-container
         infiniteScroll
         [infiniteScrollDistance]="scrollDistance"
         (scrolled)="onScrollDown()"
         [scrollWindow]="false"
         [attr.data-component]="'ncx/search/page/results/stories'">
         <div class="search-result-body">
            <!-- LOADER -->
            <app-loader-component
               loaderType="SECTION_LOADER"
               [isLoaded]="isLoaded"></app-loader-component>

            <!-- CARD TO DISPLAY SEARCH RESULTS -->
            <ncx-story-search
               *ngFor="let story of searchResults; let index = index"
               (viewStory)="viewStory($event, index)"
               [story]="story"></ncx-story-search>

            <div *ngIf="!searchResults.length && isLoaded">
               <nz-empty [nzNotFoundContent]="contentTpl">
                  <ng-template #contentTpl>
                     <span>No Stories Found</span>
                  </ng-template>
               </nz-empty>
            </div>
         </div>
      </div>
   </ng-template>
</app-scroll-container>
